/** @flow */

export default function(t: (name: string) => string) {
  return {
    identityVerificationCheck: {
      "ui:field": "multi-select",
      "ui:options": {
        label: t("IDENTIFIERS"),
      },
    },
    notificationAuditEnabled: {
      "ui:widget": "switch-button",
      "ui:options": {
        label: t("EMPLOYEE_ACCESS_AUDIT"),
        description: t("EMPLOYEE_ACCESS_AUDIT_DESCRIPTION"),
      },
    },
    notificationAuditFrequency: {
      "ui:widget": "number-input",
      "ui:options": {
        label: t("EMPLOYEE_AUDIT_FREQUENCY"),
        description: t("EMPLOYEE_AUDIT_FREQUENCY_DESCRIPTION"),
      },
    },
    "ui:order": [
      "identityVerificationCheck",
      "notificationAuditEnabled",
      "notificationAuditFrequency",
    ],
  };
}
